<mat-icon *ngIf="false" inline="true" [class]="getClass(params.data.statusCd)">lens</mat-icon>
<span>{{ getStatusName(params.data.statusCd) }}</span>
